import { useObserver } from 'mobx-react-lite';
import useStores from 'shared/hooks/use-stores';
export default function useCart() {
  var stores = useStores();
  return useObserver(function () {
    return stores.Cart;
  });
}